import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';
import { queryClient } from '@/lib/utils/queryClient';
import { findingsQueryOptions } from '../../../../-hooks/useFindingsQuery';
import type { QuickFilterMode } from '../../../../-types';
import { getDefaultFindingsMode } from '../../../../-utils/findingsMode';

interface Search {
  mode?: 'internal' | 'external' | undefined;
  page?: number | undefined;
  limit?: number | undefined;
  sort?: string | undefined;
  filters?: Record<string, string[]> | undefined;
}

export const Route = createFileRoute(
  '/(client)/capa/(pages)/(list)/findings/archived/',
)({
  loaderDeps: ({ search }: { search: Search }) => ({
    mode: (search.mode ?? getDefaultFindingsMode()) as QuickFilterMode,
    page: search.page ?? 1,
    limit: search.limit ?? 50,
    sort: search.sort,
    filters: search.filters,
  }),
  loader: ({ deps }) =>
    queryClient.ensureQueryData(
      findingsQueryOptions({
        mode: deps.mode,
        isArchiveView: true,
        page: deps.page,
        count: deps.limit,
        ...(deps.sort !== undefined ? { sort: deps.sort } : {}),
        ...(deps.filters !== undefined ? { filters: deps.filters } : {}),
      }),
    ),
  component: lazyRouteComponent(
    () => import('../../../../-components/FindingsTab'),
    'FindingsArchivedRoute',
  ),
});
